var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.328 8.51002L14.778 3.27002C13.498 2.25002 11.498 2.24002 10.228 3.26002L3.67801 8.51002C2.73801 9.26002 2.16801 10.76 2.36801 11.94L3.62801 19.48C3.91801 21.17 5.48801 22.5 7.19801 22.5H17.798C19.488 22.5 21.088 21.14 21.378 19.47L22.638 11.93C22.818 10.76 22.248 9.26002 21.328 8.51002ZM13.248 18.5C13.248 18.91 12.908 19.25 12.498 19.25C12.088 19.25 11.748 18.91 11.748 18.5V15.5C11.748 15.09 12.088 14.75 12.498 14.75C12.908 14.75 13.248 15.09 13.248 15.5V18.5Z",
    fill: "#246BFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/home-filled.5d6ef381752a9b45c5c84b6459238a53.svg";
export { ForwardRef as ReactComponent };